// extracted by mini-css-extract-plugin
export default {"loadingGroup":"loadingGroup--VDSNf","switch":"switch--fzHzg"};